'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg24 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 24, height: 25, viewBox: "0 0 24 25", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.0005 12.9928C23.0005 19.0681 18.0755 23.9931 12.0002 23.9931C5.92494 23.9931 0.999939 19.0681 0.999939 12.9928C0.999939 6.91755 5.92494 1.99255 12.0002 1.99255C18.0755 1.99255 23.0005 6.91755 23.0005 12.9928ZM13.4696 8.45928C13.4696 9.27082 12.8117 9.9287 12.0002 9.9287C11.1886 9.9287 10.5308 9.27082 10.5308 8.45928C10.5308 7.64775 11.1886 6.98987 12.0002 6.98987C12.8117 6.98987 13.4696 7.64775 13.4696 8.45928ZM12.001 11.5843C12.6637 11.5843 13.201 12.1216 13.201 12.7843L13.201 18.2073C13.201 18.87 12.6637 19.4073 12.001 19.4073C11.3382 19.4073 10.801 18.87 10.801 18.2073V12.7843C10.801 12.1216 11.3382 11.5843 12.001 11.5843Z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg24;
//# sourceMappingURL=24.js.map
